module.exports = __webpack_public_path__ + "img/company-bg.83e9bfbe.png";